import type { ParentChildMeeting } from '@repo/types/parent';
import type { UserPublic } from '@repo/types/users';

import type { GetChildScheduleParams } from './parentService';
import type { ChildrenResourceResult } from './useChildrenResource';

import { ParentKey } from './keys';
import { ParentService } from './parentService';
import { useChildrenResource } from './useChildrenResource';

/**
 * Schedules of every linked child, aggregated over the same window.
 */
export function useGetChildrenSchedule(children: UserPublic[], params?: GetChildScheduleParams, enabled = true): ChildrenResourceResult<ParentChildMeeting[]> {
  return useChildrenResource(
    children,
    (child) => [ParentKey.CHILD_SCHEDULE, child.id, params],
    (child) => ParentService.getChildSchedule(child.id, params).then((response) => response.data),
    enabled
  );
}
